import * as t from 'io-ts';

export const geolocationCodec = t.type({
  data: t.type({
    currency: t.union([t.string, t.null]),
    country: t.union([t.string, t.null]),
  }),
});
